export const billingTabs = [{ name: 'Payments', code: 0 }, { name: 'Reimbursements', code: 1 }];
